import type { Package } from 'shared/packages/domain/package';

// Placement and number are cleared so the copy cannot collide with the source package.
export function buildPackageCopy(source: Package, newId: () => string): Package {
  return {
    ...source,
    id: newId(),
    number: '',
    packageStorageAreaId: null,
    occupiedStoragePlaceIds: [],
    stackLevel: null,
    longitude: null,
    latitude: null,
    rotation: null,
    timesMovedCount: 0,
    distanceTravelledMetres: 0,
    timeCarriedSeconds: 0,
    weightedDistanceTravelledMetres: 0,
    createdAtUtc: null,
    contents: source.contents.map((content) => ({
      ...content,
      id: newId(),
      codes: content.codes.map((code) => ({ ...code, id: newId() })),
    })),
  };
}
